require('./js/curriculumManager');



// WEBPACK FOOTER //
// ./node_modules/@kathondvla/curriculum-manager/index.js